import type { ButtonHTMLAttributes, ReactNode } from 'react'
import './componentes.css'

type Variante = 'primario' | 'secundario' | 'perigo' | 'discreto'

export function Botao({
  variante = 'secundario',
  carregando = false,
  children,
  ...resto
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variante?: Variante
  carregando?: boolean
  children: ReactNode
}) {
  return (
    <button
      type="button"
      className={`botao botao--${variante}`}
      // Desabilitar durante o carregamento evita duplo envio; `aria-busy`
      // é o que informa quem não vê o giro do ícone.
      disabled={carregando || resto.disabled}
      aria-busy={carregando || undefined}
      {...resto}
    >
      {carregando && (
        <span className="botao__giro" aria-hidden="true">
          ◌
        </span>
      )}
      {children}
    </button>
  )
}
